import { defaultPost } from '@bikemap/js/utility'
import { modals, notifications, gettext } from '@bikemap/js/services'

function handleGarminDisconnectConfirm(e, modal) {
    modal.setLoading()
    defaultPost(modal.referrer.action, new FormData(modal.referrer))
        .then(res => {
            notifications.show({
                title: gettext('Garmin Connect'),
                message: gettext('You have been disconnected from Garmin Connect.'),
                type: 'success',
                icon: 'i-check',
            })
        })
        .catch(res => notifications.error(res.statusText))
        .finally(() => {
            modal.setLoading(false)
            modals.close()
        })
}

function handleGarminDisconnectSubmit(e) {
    e.preventDefault()
    modals.show('disconnect-garmin', {
        title: gettext('Are you sure?'),
        message: gettext(
            'Your Garmin activities will no longer sync with your Bikemap profile. This will not affect any previously synced Garmin activities.'
        ),
        buttons: [
            { content: gettext('Cancel'), action: 'close' },
            { content: gettext('Disconnect'), style: 'danger', action: 'submit' },
        ],
        referrer: e.target,
        onSubmit: handleGarminDisconnectConfirm,
    })
}

export function initGarminConnectForm() {
    const disconnectForm = document.getElementById('garmin-disconnect-form')
    if (disconnectForm) disconnectForm.addEventListener('submit', handleGarminDisconnectSubmit)
}
